import React from "react";
import { Arrow } from "../Icons/Arrow";
import { Link } from "react-router-dom";
import { AOSProps } from "../../global/types";

interface CTABoxProps extends AOSProps {
  target: string;
}

export const CTABox: React.FC<CTABoxProps> = ({ target, children, dataAos, dataAosDelay }) => {
  return (
    <Link className="cta-box" to={target} data-aos={dataAos} data-aos-delay={dataAosDelay}>
      {children}
      <Arrow />
    </Link>
  );
};
